export default __webpack_public_path__ + "static/media/cameraRecord.05b820ce.svg";